import * as React from 'react';

type Props = {
  path: string;
  element: React.ReactNode | ((params: Record<string, string | number>) => React.ReactNode);
};

export const Route: React.FC<Props> = () => null;
